import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import * as Styles from '../Styles';
import { Fade } from 'react-reveal';
import { getCategoryProductListUrl } from '../../../utils/exploreCategoryLinks';

function categoryAlt(name) {
  if (name === 'Entertainment & Events') return 'Entertainment';
  return name || '';
}

const Data = React.memo(() => {
  const getCategoryRoute = (categoryName) => getCategoryProductListUrl(categoryName);

  const fallbackCategories = [
    { name: 'Textile', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Textile.svg", link: getCategoryRoute('Textile') },
    { name: 'Lifestyle', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Lifestyle.png", link: getCategoryRoute('Lifestyle') },
    { name: 'Media', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Media.svg", link: getCategoryRoute('Media') },
    { name: 'Office Supply', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Office_Supply.png", link: getCategoryRoute('Office Supply') },
    { name: 'Electronics', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Electronics.svg", link: getCategoryRoute('Electronics') },
    { name: 'Hotel', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Hotel.svg", link: getCategoryRoute('Hotel') },
    { name: 'QSR', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/QSR.svg", link: getCategoryRoute('QSR') },
  ];
  const categories = fallbackCategories;
  const categories2 = [
    {
      name: 'Airline Tickets',
      image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Airline_Tickets.svg",
      link: getCategoryRoute('Airline Tickets'),
    },
    {
      name: 'Entertainment & Events',
      image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Entertainment.svg",
      link: getCategoryRoute('Entertainment & Events'),
    },
    {
      name: 'FMCG',
      image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/FMCG.svg",
      link: getCategoryRoute('FMCG'),
    },
    {
      name: 'Mobility',
      image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Mobility.svg",
      link: getCategoryRoute('Mobility'),
    },
    {
      name: 'Others',
      image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Others.svg",
      link: getCategoryRoute('Others'),
    },
  ];
  const row1 = [
    { name: 'Textile', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Textile.svg", link: getCategoryRoute('Textile') },
    { name: 'Lifestyle', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Lifestyle.png", link: getCategoryRoute('Lifestyle') },
    { name: 'Media', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Media.svg", link: getCategoryRoute('Media') },
    { name: 'Office Supply', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Office_Supply.png", link: getCategoryRoute('Office Supply') },
  ];
  const row2 = [
    { name: 'Electronics', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Electronics.svg", link: getCategoryRoute('Electronics') },
    { name: 'Hotel', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Hotel.svg", link: getCategoryRoute('Hotel') },
    { name: 'Mobility', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Mobility.svg", link: getCategoryRoute('Mobility') },
    { name: 'Airline Tickets', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Airline_Tickets.svg", link: getCategoryRoute('Airline Tickets') },
  ];
  const row3 = [
    { name: 'FMCG', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/FMCG.svg", link: getCategoryRoute('FMCG') },
    { name: 'Entertainment & Events', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Entertainment.svg", link: getCategoryRoute('Entertainment & Events') },
    { name: 'QSR', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/QSR.svg", link: getCategoryRoute('QSR') },
    { name: 'Others', image: "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/BXI_ICONS/Others.svg", link: getCategoryRoute('Others') },
  ];

  const handleClick = (link) => {
    if (!link) return;
    window.location.href = link;
  };


  return (
    <Paper elevation={0} sx={{ mt: { xl: 10, lg: 10, md: 6, sm: 4, xs: 3 }, overflow: 'visible' }}>
      <Box sx={{ width: '90%', mx: 'auto', overflow: 'visible' }}>
        <Fade top duration={1000}>
          <Box
            component="h1"
            sx={{
              m: 0,
              p: 0,
              fontSize: 'unset',
              fontWeight: 'unset',
              lineHeight: 'normal',
              overflow: 'visible',
            }}
          >
            <Typography
              component="span"
              sx={{
                ...Styles.headText,
                display: 'block',
                mb: 0,
                width: '100%',
                ml: { xl: 0, lg: 0, md: 0, sm: 0, xs: 0 },
                lineHeight: { xl: '32px', lg: '32px', md: '28px', sm: '26px', xs: '22px' },
              }}
            >
              Do You
              <span style={{ color: ' rgba(108, 108, 162, 1)' }}> Own or</span>
            </Typography>
            <Typography
              component="span"
              sx={{
                ...Styles.headText,
                color: 'rgba(107, 82, 148, 1)',
                display: 'block',
                mb: 0,
                width: '100%',
                ml: { xl: 0, lg: 0, md: 0, sm: 0, xs: 0 },
                lineHeight: { xl: '32px', lg: '32px', md: '28px', sm: '26px', xs: '22px' },
              }}
            >
              Operate &nbsp;
              <span style={{ color: 'rgba(35, 36, 42, 1)' }}>a Business In</span>
            </Typography>
          </Box>
        </Fade>
      </Box>
      {/*  */}
      <Box
        sx={{
          width: '100%',
          background: 'rgba(108, 108, 162, 0.09)',
          p: { xl: 4, lg: 4, md: 3, sm: 0.5, xs: 0.5 },
          mt: 2,
          height: 'auto',
        }}
      >
        <Box
          sx={{
            width: '94%',
            mx: 'auto',
          }}
        >
          <Typography sx={{ ...Styles.smallHeadText, fontWeight: 400 }}>
            ACTIVE Categories
          </Typography>
        </Box>
        <Box mt={2} sx={caregoriesBoxStyle}>
          {categories?.map((item, index) => (
            <Box
              key={index}
              sx={Styles.insideCategoryBox}
              onClick={() => handleClick(item?.link)}
            >
              <Box sx={categoriesStyle}>
                <img src={item?.image} alt={categoryAlt(item?.name)} width={30} height={30} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
              </Box>
              <Typography sx={Styles.categoryText}>{item?.name}</Typography>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            ...caregoriesBoxStyle,
            width: { xl: '70%', lg: '70%', md: '90%', sm: '90%', xs: '90%' },
            justifyContent: {
              xl: 'space-around',
              lg: 'space-around',
              md: 'center',
            },
            mt: { xl: 3, lg: 3, md: 3, sm: 1, xs: 1 },
          }}
        >
          {categories2?.map((item, index) => (
            <Box
              key={index}
              sx={Styles.insideCategoryBox}
              onClick={() => handleClick(item?.link)}
            >
              <Box sx={categoriesStyle}>
                <img src={item?.image} alt={categoryAlt(item?.name)} width={30} height={30} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
              </Box>
              <Typography sx={Styles.categoryText}>{item?.name}</Typography>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            width: '96%',
            mx: 'auto',
            overflowX: 'scroll',
            '::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          <Box sx={caregoriesSmallBoxStyle}>
            {row1?.map((item, index) => (
              <Box
                key={index}
                sx={Styles.insideCategorySmallBox}
                onClick={() => handleClick(item?.link)}
              >
                <Box sx={categoriesStyle}>
                <img src={item?.image} alt={categoryAlt(item?.name)} width={30} height={30} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
              </Box>
                <Typography sx={Styles.categoryText}>{item?.name}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={caregoriesSmallBoxStyle}>
            {row2?.map((item, index) => (
              <Box
                key={index}
                sx={Styles.insideCategorySmallBox}
                onClick={() => handleClick(item?.link)}
              >
                <Box sx={categoriesStyle}>
                <img src={item?.image} alt={categoryAlt(item?.name)} width={30} height={30} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
              </Box>
                <Typography sx={Styles.categoryText}>{item?.name}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={caregoriesSmallBoxStyle}>
            {row3?.map((item, index) => (
              <Box
                key={index}
                sx={Styles.insideCategorySmallBox}
                onClick={() => handleClick(item?.link)}
              >
                <Box sx={categoriesStyle}>
                <img src={item?.image} alt={categoryAlt(item?.name)} width={30} height={30} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
              </Box>
                <Typography sx={Styles.categoryText}>{item?.name}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
});

export default Data;

const categoriesStyle = {
  width: { xl: '30px', lg: '30px', md: '30px', sm: '16px', xs: '16px' },
  height: { xl: '30px', lg: '30px', md: '30px', sm: '16px', xs: '16px' },
  objectFit: 'contain',
  py: 1,
};

const caregoriesBoxStyle = {
  width: { xl: '90%', lg: '90%', md: '100%' },
  mx: 'auto',
  display: {
    xl: 'flex',
    lg: 'flex',
    md: 'flex',
    sm: 'none',
    xs: 'none',
  },
  justifyContent: { xl: 'space-around', lg: 'space-around', md: 'flex-start' },
  gap: 2,
  flexWrap: 'wrap',
};

const caregoriesSmallBoxStyle = {
  width: '100%',
  mx: 'auto',
  display: {
    xl: 'none',
    lg: 'none',
    md: 'none',
    sm: 'flex',
    xs: 'flex',
  },
  justifyContent: { sm: 'space-around', xs: 'flex-start' },
  gap: 2,
  flexWrap: 'nowrap',
};


